var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1735,
    r: 12,
    fill: "#5B78FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 6.17346H5.14286C4.83975 6.17346 4.54906 6.29989 4.33474 6.52493C4.12041 6.74998 4 7.0552 4 7.37346V16.9735C4 17.2917 4.12041 17.5969 4.33474 17.822C4.54906 18.047 4.83975 18.1735 5.14286 18.1735H18.8571C19.1602 18.1735 19.4509 18.047 19.6653 17.822C19.8796 17.5969 20 17.2917 20 16.9735V7.37346C20 7.0552 19.8796 6.74998 19.6653 6.52493C19.4509 6.29989 19.1602 6.17346 18.8571 6.17346ZM17.6 7.37346L12 11.4415L6.4 7.37346H17.6ZM5.14286 16.9735V7.91946L11.6743 12.6655C11.7699 12.7351 11.8836 12.7725 12 12.7725C12.1164 12.7725 12.2301 12.7351 12.3257 12.6655L18.8571 7.91946V16.9735H5.14286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDesk);
export default __webpack_public_path__ + "static/media/Email-desk.bc4c3b57.svg";
export { ForwardRef as ReactComponent };